@if (isMultiText()) {
    <div class="sh-column-filter" shClickOutside (shClickOutside)="close()">
        <sh-droppanel [isOpen$]="isOpen$" [inOverflownContainer]="true">
            <div droppanelToggle class="sh-column-filter__toggle">
                <sh-action-item [item]="toggleAction()"></sh-action-item>
                @if (isActive()) {
                    <span class="sh-column-filter__active-dot"></span>
                }
            </div>
            <div class="sh-column-filter__panel">
                <!-- Every input carries `#textInput`; the single view query resolves to the first, which is the one open-focus wants. -->
                @for (textField of textFields(); track textField.field) {
                    <div class="sh-column-filter__field">
                        <label class="sh-column-filter__field-label" [attr.for]="inputId(textField.field)">
                            {{ textField.label }}
                        </label>
                        <div class="sh-column-filter__input">
                            <input
                                [attr.id]="inputId(textField.field)"
                                [attr.data-field]="textField.field"
                                #textInput
                                class="sh-form-group__input sh-input-field sh-column-filter__input__field"
                                type="text"
                                [attr.placeholder]="'column-filter.placeholder' | translate"
                                [value]="fieldInputValue(textField.field)"
                                (input)="onFieldInput(textField.field, $any($event.target).value)"
                            />
                            @if (fieldInputValue(textField.field).length > 0) {
                                <button
                                    type="button"
                                    class="sh-column-filter__clear"
                                    [attr.aria-label]="'column-filter.clear' | translate"
                                    (click)="clearFieldInput(textField.field)"
                                >
                                    <svg sh-icon name="close" aria-hidden="true"></svg>
                                </button>
                            }
                        </div>
                    </div>
                }
            </div>
        </sh-droppanel>
    </div>
} @else if (isTextFilterable()) {
    <div class="sh-column-filter" shClickOutside (shClickOutside)="close()">
        <sh-droppanel [isOpen$]="isOpen$" [inOverflownContainer]="true">
            <div droppanelToggle class="sh-column-filter__toggle">
                <sh-action-item [item]="toggleAction()"></sh-action-item>
                @if (isActive()) {
                    <span class="sh-column-filter__active-dot"></span>
                }
            </div>
            <div class="sh-column-filter__panel">
                <div class="sh-column-filter__input">
                    <input
                        #textInput
                        class="sh-form-group__input sh-input-field sh-column-filter__input__field"
                        type="text"
                        [attr.placeholder]="'column-filter.placeholder' | translate"
                        [attr.aria-label]="'column-filter.toggle' | translate"
                        [value]="inputValue()"
                        (input)="onInput($any($event.target).value)"
                    />
                    @if (inputValue().length > 0) {
                        <button
                            type="button"
                            class="sh-column-filter__clear"
                            [attr.aria-label]="'column-filter.clear' | translate"
                            (click)="clearInput()"
                        >
                            <svg sh-icon name="close" aria-hidden="true"></svg>
                        </button>
                    }
                </div>
            </div>
        </sh-droppanel>
    </div>
} @else if (isFacet()) {
    <div class="sh-column-filter" shClickOutside (shClickOutside)="close()">
        <sh-droppanel [isOpen$]="isOpen$" [inOverflownContainer]="true">
            <div droppanelToggle class="sh-column-filter__toggle">
                <sh-action-item [item]="toggleAction()"></sh-action-item>
                @if (isActive()) {
                    <span class="sh-column-filter__active-dot"></span>
                }
            </div>
            <div class="sh-column-filter__panel">
                <sh-facet
                    [facet]="enumFacet()"
                    [showLabel]="false"
                    [blockShowMore]="true"
                    (valueSelected)="facetValueSelected.emit($event)"
                ></sh-facet>
                @if (isActive()) {
                    <div class="sh-action-group -sh-align-end -sh-condense sh-column-filter__actions">
                        <button
                            type="button"
                            class="sh-button--secondary sh-action-group__item"
                            (click)="enumCleared.emit()"
                        >
                            {{ 'column-filter.clear' | translate }}
                        </button>
                    </div>
                }
            </div>
        </sh-droppanel>
    </div>
} @else if (isDate()) {
    <div class="sh-column-filter sh-column-filter--date" shClickOutside (shClickOutside)="close()">
        <sh-droppanel [isOpen$]="isOpen$" [inOverflownContainer]="true" [height]="460">
            <div droppanelToggle class="sh-column-filter__toggle">
                <sh-action-item [item]="toggleAction()"></sh-action-item>
                @if (isActive()) {
                    <span class="sh-column-filter__active-dot"></span>
                }
            </div>
            <div class="sh-column-filter__panel">
                <sh-column-date-filter
                    [value]="value()"
                    (rangeChanged)="onDateRangeChanged($event)"
                ></sh-column-date-filter>
            </div>
        </sh-droppanel>
    </div>
}
